import { ToasterPublicMethods, ToastProps } from '@gravity-ui/uikit';

type TPropsWithToaster<T> = T & {
    toaster: ToasterPublicMethods;
};

export const addToast = <T>(componentProps: T, toast: Omit<ToastProps, 'name'>, toastName = 'generalToast') => {
    const toaster = (componentProps as TPropsWithToaster<typeof componentProps>)?.toaster;
    if (toaster) {
        toaster.add({ name: toastName, ...toast });
    } else {
        console.warn('@addToast use toaster without ToastProvider');
    }
};
